export const Account = {
    "用户名":"用户名",
    "邮箱/手机号":"邮箱/手机号",
    "请输入您的邮箱/手机号":"请输入您的邮箱/手机号",
    "请输入要绑定邮箱手机号":"请输入要绑定邮箱/手机号",
    "请填邮箱/手机号":"请填邮箱/手机号",
    "验证码":"验证码",
    "请输入验证码":"请输入验证码",
    "请输入计算结果":"请输入计算结果",
    "提交":"提交",
    "请输入密码":"请输入密码",
    "请填写密码":"请填写密码",
    "确认密码":"确认密码",
    "请再次输入":"请再次输入",
    "两次输入的密码不一致请您检查密码":"两次输入的密码不一致，请您检查密码",
    "已发送验证码至":"已发送验证码至",
    "注册并登陆":"注册并登陆",
    "账号类型错误":"账号类型错误",
    "邮箱账号手机号":"邮箱/账号/手机号",
    "请输入邮箱手机号":"请输入邮箱/手机号",
    "还没有账号":"还没有账号？",
    "立即注册并绑定":"立即注册并绑定",
    "注册并绑定":"注册并绑定",
    "请检查登录信息":"请检查登录信息",
    "没有读取到code_key":"没有读取到code_key",
    "登录失败":"登录失败",
    "请检查密码格式应大于6位":"请检查密码格式，应大于6位",
    "两次密码应该相同":"两次密码应该相同",
    "请检查账号格式":"请检查账号格式",
    "绑定账号":"绑定账号",
    "请输入右侧图片验证码":"请输入右侧图片验证码",
    "短信":"短信",
    "邮箱或短信验证码":"邮箱或短信验证码",
    "确认重置密码":"确认重置密码",
    "验证":"验证",
    "找回密码":"找回密码",
    "发送验证码失败账户类型不对":"发送验证码失败，账户类型不对",
    "重置密码":"重置密码",
    "密码修改成功请前去登陆":"密码修改成功，请前去登陆",
    "账号密码登录":"账号密码登录",
    "快速注册登录":"快速注册/登录",
    "请输入手机号":"请输入手机号",
    "请输入短信验证码":"请输入短信验证码",
    "获取验证码":"获取验证码",
    "请输入账号手机邮箱":"请输入账号/手机/邮箱",
    "忘记密码":"忘记密码",
    "没有账号":"没有账号?",
    "去注册":"去注册?",
    "微信登录":"微信登录",
    "注册登录":"注册/登录",
    "登录":"登录",
    "请输入用户名":"请输入用户名",
    "请输入6位以上密码":"请输入6位以上密码",
    "邮箱验证":"邮箱验证",
    "短信验证":"短信验证",
    "类型错误":"类型错误",
    "正在登录中":"正在登录中...",
    "请输入正确格式的账号":"请输入正确格式的账号",
    "密码强度过低":"密码强度过低",
    "选择身份":"选择身份",
    "请输入或者选择学校":"请输入或者选择学校",
    "立即注册":"立即注册",
    "添加老师助教":"添加老师/助教",
    "老师助教":"老师/助教",
    "请输入课堂派账号手机邮箱":"请输入课堂派账号/手机/邮箱",
    "添加老师助教成功":"添加老师/助教成功",
    "全部学生":"全部学生",
    "按标签":"按标签",
    "机构选课名单":"机构选课名单",
    "新建标签":"新建标签",
    "删除成员":"删除成员",

}